export default __webpack_public_path__ + "static/media/flag-lithuania.5dc84450.svg";